module.exports = __webpack_public_path__ + "img/private-label.e9b0a9ac.svg";